/**
 * What a return-page sign-in keeps in this tab between `auth/begin` and the return page. MusicAPI
 * gives the session uuid back in `state`, so only the artist is kept: the route of `auth/complete`
 * names the account, and the server refuses a session of another account. Per tab:
 * `sessionStorage`. Every access can throw (a private window); then the page uses the active artist.
 */
const SESSION_KEY = 'm24PortalReturnConnect';

export function rememberPortalReturn(sessionUuid: string, accountId: number): void {
  try {
    window.sessionStorage.setItem(SESSION_KEY, JSON.stringify({ sessionUuid, accountId }));
  } catch {
    // The return page falls back to the active artist.
  }
}

/** The artist of the sign-in with this session uuid, or null when this tab did not start it. */
export function portalReturnAccount(sessionUuid: string): number | null {
  try {
    const raw = window.sessionStorage.getItem(SESSION_KEY);
    if (raw === null) {
      return null;
    }
    const stored = JSON.parse(raw) as { sessionUuid?: unknown; accountId?: unknown };
    return stored.sessionUuid === sessionUuid && typeof stored.accountId === 'number' ? stored.accountId : null;
  } catch {
    return null;
  }
}

export function forgetPortalReturn(): void {
  try {
    window.sessionStorage.removeItem(SESSION_KEY);
  } catch {
    // Nothing to forget.
  }
}
